import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./PendingUsersList.module.css";
import PendingUsersItem from "../PendingUsersItem";
import { useUsersData } from "DreamStream/UsersPage/useUsersData";

/**
 * View component. Scrollable list of users with a header.
 */
export function PendingUsersList({ posts }) {
  const { data, status } = useUsersData("posts");

  const [usersData, setUsersData] = useState([posts]);

  useEffect(() => {
    if (status === "success") {
      setUsersData([...data]);
    }
  }, [data, status]);

  return (
    <div className={styles.container}>
      <div className={styles.headerGrid}>
        <div className={styles.headerItem}>IBO</div>
        <div className={styles.headerItem}>IBO #</div>
        <div className={styles.headerItem}>Pin</div>
        <div className={styles.headerItem}>Premier Since</div>
      </div>

      <div className={styles.usersContainer}>
        {usersData.map((post, index) => (
          <div
            className={
              index % 2 === 0 ? styles.backgroundWhite : styles.backgroundGray
            }
          >
            <PendingUsersItem
              userInfo={{
                name: post.name,
                iboNum: post.iboNum,
                pin: post.pin,
                premierSince: post.premierSince,
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

PendingUsersList.propTypes = {
  /**
   * Array of posts objects.
   */
  posts: PropTypes.arrayOf(PropTypes.object),
};
